import Context from "./components/Context";
export * from "./icons";
export * from "./components/twoTonePrimaryColor";
export { default as createFromIconfontCN } from "./components/IconFont";
export { default } from "./components/Icon";
export var IconProvider = Context.Provider;